<template>
	<div class="position-relative" :class="{imageMinHeight: imagesExpanded || !contentData.expandable}">
        <div v-if="!authenticated">
            <a @click="expandNextSection" :class="{'clickableImage': contentData.toggleSections}">
                <div v-if="imagesExpanded || !contentData.expandable" class="d-none d-sm-block" v-bind:style="backgroundSize">
                    <img v-bind:id="'content'+index" v-bind:src="backgroundImage" v-on:load="onLoad(index)" class="img-fluid" alt="Responsive image">
                    <div class="loading" v-bind:id="'loader'+index">
                        <i class="fa fa-spinner fa-pulse fa-5x"></i>
                    </div>
                </div>
                <div v-if="imagesExpanded || !contentData.expandable" class="d-block d-sm-none" v-bind:style="backgroundSize">
                    <img v-bind:id="'mobilecontent'+index" v-bind:src="mobileBackgroundImage" v-on:load="onMobileLoad(index)" class="img-fluid" alt="Responsive image">
                    <div class="loading" v-bind:id="'mobileloader'+index">
                        <i class="fa fa-spinner fa-pulse fa-5x"></i>
                    </div>
                </div>
            </a>
        </div>
		<div v-if="authenticated">
			<div class="row m-2">
				<div class="col-sm">
					<label>Desktop picture</label>
					<vue-dropzone ref="computerDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="uploadedFile" />
				</div>
				<div class="col-sm">
					<label>Mobile picture</label>
					<vue-dropzone ref="mobileDropzone" id="dropzonemobile" :options="dropzoneMobileOptions" v-on:vdropzone-success="uploadedMobileFile" />
				</div>
			</div>
			<div class="row m-2">
                <div class="col">
                    <div class="form-check">
                        <input type="checkbox" v-model="contentData.expandable" class="form-check-input" id="exampleCheck1">
                        <label class="form-check-label" for="exampleCheck1">Make image expandable</label>
                    </div>
					<div class="form-group">
						<label for="exampleCheck1">Toggle sections</label>
						<input type="number" v-model.number="contentData.toggleSections" class="form-control" id="exampleCheck1">
					</div>
                </div>
			</div>
		</div>  
	</div>
</template>

<script>import $ from 'jquery';

    export default {
        name: 'imagecontent-component',
        props: ['contentData', 'index', 'hide', 'dragging', 'authenticated', 'imagesExpanded'],
        data() {
            return {
                dropzoneOptions: {
                    url: "/api/file/uploadfiles",
                    thumbnailWidth: 100,
                    thumbnailHeight: 100,
                    maxFilesize: 1
                },
                dropzoneMobileOptions: {
                    url: "/api/file/uploadfiles",
                    thumbnailWidth: 100,
                    thumbnailHeight: 100,
                    maxFilesize: 0.7
                },
                loaded: false,
                backgroundImage: '',
                mobileBackgroundImage: ''
            }
        },
        computed: {
            backgroundSize() {
                if (this.loaded)
                    return {
                        'background-color': '#1d2124'
                    };
                else
                    return {
                        minHeight: (this.contentData.backgroundImageHeight / this.contentData.backgroundImageWidth * 100) + 'vw',
                        'background-color': '#1d2124'
                    };
            },
            mobileBackground() {

            }
        },
        mounted() {
            var self = this;

            setTimeout(function(){
                self.backgroundImage = self.contentData.backgroundImage;
                self.mobileBackgroundImage = self.contentData.mobileBackgroundImage;
            }, 200);

            if (this.$refs.computerDropzone) {
                this.$refs.computerDropzone.removeAllFiles();

                if (this.contentData.backgroundImage) {
                    var mockFile = { id: 1, name: "Computer image", size: 150 };
                    this.$refs.computerDropzone.manuallyAddFile(mockFile, this.contentData.backgroundImage);
                }
            }

            if (this.$refs.mobileDropzone) {
                this.$refs.mobileDropzone.removeAllFiles();

                if (this.contentData.mobileBackgroundImage) {
                    var mockMobileFile = { id: 1, name: "Mobile image", size: 150 };
                    this.$refs.mobileDropzone.manuallyAddFile(mockMobileFile, this.contentData.mobileBackgroundImage);
                }
            }
        },
        methods: {
            onLoad(index) {
                $('#content' + index).fadeIn();
                $('#loader' + index).fadeOut();
                this.loaded = true;
            },
            onMobileLoad(index) {
                $('#mobilecontent' + index).fadeIn();
                $('#mobileloader' + index).fadeOut();
                this.loaded = true;
            },
            uploadedFile: function (file, response) {
                if (this.$refs.computerDropzone.dropzone.files.length > 1)
                    this.$refs.computerDropzone.removeFile(this.$refs.computerDropzone.dropzone.files[0])

                this.contentData.backgroundImage = response.url;
                this.contentData.backgroundImageWidth = file.width;
                this.contentData.backgroundImageHeight = file.height;
            },
            uploadedMobileFile: function (file, response) {
                if (this.$refs.mobileDropzone.dropzone.files.length > 1)
                    this.$refs.mobileDropzone.removeFile(this.$refs.mobileDropzone.dropzone.files[0])

                this.contentData.mobileBackgroundImage = response.url;
                this.contentData.mobileBackgroundImageWidth = file.width;
                this.contentData.mobileBackgroundImageHeight = file.height;
            },
            expandNextSection() {
                if (!this.contentData.toggleSections)
                    return;

                //if ($(this.$el).parent().next().is(":visible") == false)
                //    $('html, body').animate({
                //        scrollTop: $(this.$el).parent().next().offset().top - 50
                //    }, 500);

				$(this.$el).parent().nextAll().slice(0, this.contentData.toggleSections).slideToggle();
            }
        }
    };</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.img-fluid {
		width: 100%;
	}

	.bottom-right {
		position: absolute;
		bottom: 16px;
		right: 16px;
	}

	.loading {
		z-index: 1001;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		color: #fff;
	}

    .imageMinHeight {
        min-height: 100px
    }

    .clickableImage div {
        margin: 10px;
    }

    .clickableImage div:active {
        opacity: 0.75;
    }

    @media only screen and (min-width : 992px) {
        .clickableImage {
            cursor: pointer;
        }

        .clickableImage div:hover {
            opacity: 0.75;
        }
    }
</style>
